import React from 'react';
import * as ST from '@r1-frontend/ui-react/components/loaders/Throbber/styled';
var Throbber = function (_a) {
    var waitStatus = _a.waitStatus, position = _a.position, color = _a.color, className = _a.className, isLoading = _a.isLoading, animation = _a.animation, _b = _a.size, size = _b === void 0 ? 1 : _b;
    return (<ST.Wrapper hide={waitStatus} position={position} className={className} size={size}>
            {[ST.FirstBlock, ST.SecondBlock, ST.ThirdBlock].map(function (Element, index) { return (<Element key={index} bgColor={color} isLoading={isLoading} animation={animation}/>); })}
        </ST.Wrapper>);
};
export default Throbber;
